module.exports = __webpack_public_path__ + "static/media/natationJ1_2024.4c2ac76b.png";